import { CustomFieldOptionType, CustomFieldType } from "./CustomFieldTypes";

// Set the custom field type options
export const getFieldTypeOptions = ({ supportsPhotoField, supportsSignatureField }: { 
    supportsPhotoField: boolean; 
    supportsSignatureField: boolean;
}): { value: CustomFieldType['field_type']; name: string }[] => {
    return [
        {
            value: 'input',
            name: 'custom_field.field_type.input',
        },
        {
            value: 'textarea',
            name: 'custom_field.field_type.textarea',
        },
        {
            value: 'dropdown',
            name: 'custom_field.field_type.dropdown',
        },
        {
            value: 'checkbox',
            name: 'custom_field.field_type.checkbox',
        },
        {
            value: 'boolean',
            name: 'custom_field.field_type.boolean',
        },
        {
            value: 'tabs',
            name: 'custom_field.field_type.tabs',
        },
        {
            value: 'yes_no',
            name: 'custom_field.field_type.yes_no',
        },
        {
            value: 'acceptable',
            name: 'custom_field.field_type.acceptable',
        },
        {
            value: 'compliant',
            name: 'custom_field.field_type.compliant',
        },
        {
            value: 'amount',
            name: 'custom_field.field_type.amount',
        },
        {
            value: 'number',
            name: 'custom_field.field_type.number',
        },
        {
            value: 'date',
            name: 'custom_field.field_type.date',
        },
        {
            value: 'time',
            name: 'custom_field.field_type.time',
        },
        ...(supportsPhotoField ? [{
            value: 'photo' as CustomFieldType['field_type'],
            name: 'custom_field.field_type.photo',
        }] : []),
        ...(supportsSignatureField ? [{
            value: 'signature' as CustomFieldType['field_type'],
            name: 'custom_field.field_type.signature',
        }] : []),
    ];
};

// Set the fixed option presets
export const optionPresets: Partial<Record<CustomFieldType['field_type'], CustomFieldOptionType[]>> = {
    yes_no: [
        { label: 'custom_field.option_presets.yes', value: 'yes', ordering: 1 },
        { label: 'custom_field.option_presets.no', value: 'no', ordering: 2 },
        { label: 'custom_field.option_presets.not_applicable', value: 'not_applicable', ordering: 3 },
    ],
    acceptable: [
        { label: 'custom_field.option_presets.good', value: 'good', ordering: 1 },
        { label: 'custom_field.option_presets.not_good', value: 'not_good', ordering: 2 },
        { label: 'custom_field.option_presets.not_applicable', value: 'not_applicable', ordering: 3 },
    ],
    compliant: [
        { label: 'custom_field.option_presets.compliant', value: 'compliant', ordering: 1 },
        { label: 'custom_field.option_presets.non_compliant', value: 'non_compliant', ordering: 2 },
        { label: 'custom_field.option_presets.not_applicable', value: 'not_applicable', ordering: 3 },
    ],
};